if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      if (FoxTheme.config.motionReduced) return;

      this.promotion = this.querySelector('.promotion');
      this.isEnhanced = this.dataset.sectionId === "template--24037241618802__scrolling_promotion_CyYTYL"; // 📌 특정 섹션인지 확인
      this.isDragging = false;
      this.startX = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.isPausedByUser = false;
      this.autoSlideInterval = null;
      this.numClones = 8; // 🔥 루프를 위한 슬라이드 복사 개수

      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }

    init() {
      if (this.childElementCount === 1) {
        

        if (this.isEnhanced) {
          this.promotion.classList.add('promotion--manual');

          this.startAutoSlide();
          
          this.setupInfiniteLoop();
          
          this.addHoverEvents();
          
          this.addDragEvents();
        }

        else {
          this.promotion.classList.add('promotion--animated');
          
          for (let index = 0; index < 10; index++) {
            this.clone = this.promotion.cloneNode(true);
            this.appendChild(this.clone);
          }
          // 모든 `scrolling-promotion`에서 Intersection Observer 적용
          const observer = new IntersectionObserver(
            (entries, _observer) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.scrollingPlay();
                } else {
                  this.scrollingPause();
                }
              });
            },
            { rootMargin: '0px 0px 50px 0px' }
          );
  
          observer.observe(this);
        }
      }
    }


    // 📌 모든 `scrolling-promotion`에서 적용
    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }

    setupInfiniteLoop() {
      const items = Array.from(this.promotion.children);
      const firstClones = items.slice(0, this.numClones).map((item) => item.cloneNode(true));
      const lastClones = items.slice(-this.numClones).map((item) => item.cloneNode(true));

      // 앞쪽에 마지막 몇 개의 슬라이드 추가
      lastClones.forEach((clone) => this.promotion.insertBefore(clone, items[0]));

      // 뒤쪽에 첫 번째 몇 개의 슬라이드 추가
      firstClones.forEach((clone) => this.promotion.appendChild(clone));

      // 시작 위치 조정
      const slideWidth = items[0].offsetWidth;
      this.currentTranslate = -slideWidth * this.numClones;
      this.promotion.style.transform = `translateX(${this.currentTranslate}px)`;
    }

    startAutoSlide() {
      this.stopAutoSlide(); 

      this.autoSlideInterval = setInterval(() => {
        this.currentTranslate -= 2;
        this.promotion.style.transition = "transform 0.2s linear";
        this.promotion.style.transform = `translateX(${this.currentTranslate}px)`;
        
        this.checkInfiniteLoop();
      }, 50);
    }

    stopAutoSlide() {
      clearInterval(this.autoSlideInterval);
    }

    checkInfiniteLoop() {
      const items = Array.from(this.promotion.children);
      const slideWidth = items[this.numClones].offsetWidth;

      // 첫 번째 복사된 슬라이드가 사라질 때 원래 위치로 이동
      if (this.currentTranslate <= -slideWidth * (items.length - this.numClones) + 1) {
        this.promotion.style.transition = "none"; // 애니메이션 제거
        this.currentTranslate = -slideWidth * this.numClones;
        this.promotion.style.transform = `translateX(${this.currentTranslate}px)`;
        setTimeout(() => {
          this.promotion.style.transition = "transform 0.3s ease-out"; // 애니메이션 복구
        }, 50);
      }

      // 맨 끝에서 처음으로 이동
      if (this.currentTranslate >= 0) {
        this.promotion.style.transition = "none"; // 애니메이션 제거
        this.currentTranslate = -slideWidth * (items.length - this.numClones * 2);
        this.promotion.style.transform = `translateX(${this.currentTranslate}px)`;
        setTimeout(() => {
          this.promotion.style.transition = "transform 0.3s ease-out"; // 애니메이션 복구
        }, 50);
      }
    }

    addHoverEvents() {
      this.addEventListener("mouseenter", () => {
        this.isPausedByUser = true;
        this.stopAutoSlide();
      });

      this.addEventListener("mouseleave", () => {
        this.isPausedByUser = false;
        this.startAutoSlide();
      });
    }

    addDragEvents() {
      const slider = this.promotion;
      let isDragging = false;
      let startX = 0;
      let prevTranslate = 0;
      let lastMoveTime = 0;
      let velocity = 0;

      slider.querySelectorAll("img").forEach((img) => {
        img.addEventListener("dragstart", (e) => e.preventDefault());
      });

      const startDrag = (clientX) => {
        isDragging = true;
        startX = clientX;
        prevTranslate = this.currentTranslate;
        lastMoveTime = Date.now();
        this.stopAutoSlide(); 
        slider.style.transition = "none"; 
      };

      const moveDrag = (clientX) => {
        if (!isDragging) return;
        const diffX = clientX - startX;
        const currentTime = Date.now();
        const timeDiff = currentTime - lastMoveTime;

        velocity = diffX / (timeDiff || 1);
        lastMoveTime = currentTime;

        if (Math.abs(velocity) > 50) {
          velocity = 50 * Math.sign(velocity);
        }

        this.currentTranslate = prevTranslate + diffX;
        slider.style.transform = `translateX(${this.currentTranslate}px)`;
      };

      const endDrag = () => {
        if (!isDragging) return;
        isDragging = false;
        slider.style.transition = "transform 0.3s ease-out"; 

        const slideWidth = this.querySelector(".promotion__item").offsetWidth;
        const index = Math.round(this.currentTranslate / -slideWidth);
        this.currentTranslate = index * -slideWidth;
        slider.style.transform = `translateX(${this.currentTranslate}px)`;

        requestAnimationFrame(() => {
          slider.style.transition = "transform 0.3s ease-out";
          slider.style.transform = `translateX(${this.currentTranslate}px)`;
        });

        this.checkInfiniteLoop();

        setTimeout(() => {
          this.startAutoSlide();
        }, 1000);
        setTimeout(() => {
          this.checkInfiniteLoop();
        }, 300);
      };

      slider.addEventListener("mousedown", (e) => {
        e.preventDefault();
        startDrag(e.clientX);
      });

      slider.addEventListener("mousemove", (e) => {
        e.preventDefault();
        moveDrag(e.clientX);
      });

      slider.addEventListener("mouseup", endDrag);
      slider.addEventListener("mouseleave", endDrag);

      slider.addEventListener("touchstart", (e) => startDrag(e.touches[0].clientX));
      slider.addEventListener("touchmove", (e) => moveDrag(e.touches[0].clientX));
      slider.addEventListener("touchend", endDrag);
    }
  }

  customElements.define('scrolling-promotion', ScrollingPromotion);
}


// if (!customElements.get('scrolling-promotion')) {
//   class ScrollingPromotion extends HTMLElement {
//     constructor() {
//       super();
//       if (FoxTheme.config.motionReduced) return;

//       const targetSectionId = "template--24037241618802__scrolling_promotion_CyYTYL";

//       this.promotion = this.querySelector('.promotion');
//       this.isDragging = false;
//       this.startX = 0;
//       this.currentTranslate = 0;
//       this.prevTranslate = 0;
//       this.velocity = 0;
//       this.lastMoveTime = 0;
//       this.isPausedByUser = false;
//       this.autoSlideInterval = null;
//       this.numClones = 8;

//       FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
//     }
    
//     init() {
//       if (this.childElementCount === 1) {
//         if (!this.dataset.sectionId || this.dataset.sectionId !== targetSectionId) {
//             this.promotion.classList.add('promotion--animated');
  
//           for (let index = 0; index < 10; index++) {
//             this.clone = this.promotion.cloneNode(true);
//             this.appendChild(this.clone);
//           }
  
//           // pause when out of view
//           const observer = new IntersectionObserver(
//             (entries, _observer) => {
//               entries.forEach((entry) => {
//                 if (entry.isIntersecting) {
//                   this.scrollingPlay();
//                 } else {
//                   this.scrollingPause();
//                 }
//               });
//             },
//             { rootMargin: '0px 0px 50px 0px' }
//           );
  
//           observer.observe(this);
//         }
//         else{
//           this.promotion.classList.add('promotion--manual');

//           this.startAutoSlide();
          
//           this.setupInfiniteLoop();
          
//           this.addHoverEvents();
          
//           this.addDragEvents();
//         }
        
//       }
//     }

//     setupInfiniteLoop() {
//       const items = Array.from(this.promotion.children);
//       const firstClones = items.slice(0, this.numClones).map((item) => item.cloneNode(true));
//       const lastClones = items.slice(-this.numClones).map((item) => item.cloneNode(true));

//       // 앞쪽에 마지막 몇 개의 슬라이드 추가
//       lastClones.forEach((clone) => this.promotion.insertBefore(clone, items[0]));

//       // 뒤쪽에 첫 번째 몇 개의 슬라이드 추가
//       firstClones.forEach((clone) => this.promotion.appendChild(clone));

//       // 시작 위치 조정
//       const slideWidth = items[0].offsetWidth;
//       this.currentTranslate = -slideWidth * this.numClones;
//       this.promotion.style.transform = `translateX(${this.currentTranslate}px)`;
//     }

//     startAutoSlide() {
//       this.stopAutoSlide(); 

//       this.autoSlideInterval = setInterval(() => {
//         this.currentTranslate -= 2;
//         this.promotion.style.transition = "transform 0.2s linear";
//         this.promotion.style.transform = `translateX(${this.currentTranslate}px)`;
        
//         this.checkInfiniteLoop();
//       }, 50);
//     }

//     stopAutoSlide() {
//       clearInterval(this.autoSlideInterval);
//     }

//     checkInfiniteLoop() {
//       const items = Array.from(this.promotion.children);
//       const slideWidth = items[this.numClones].offsetWidth;

//       // 첫 번째 복사된 슬라이드가 사라질 때 원래 위치로 이동
//       if (this.currentTranslate <= -slideWidth * (items.length - this.numClones) + 1) {
//         this.promotion.style.transition = "none"; // 애니메이션 제거
//         this.currentTranslate = -slideWidth * this.numClones;
//         this.promotion.style.transform = `translateX(${this.currentTranslate}px)`;
//         setTimeout(() => {
//           this.promotion.style.transition = "transform 0.3s ease-out"; // 애니메이션 복구
//         }, 50);
//       }

//       // 맨 끝에서 처음으로 이동
//       if (this.currentTranslate >= 0) {
//         this.promotion.style.transition = "none"; // 애니메이션 제거
//         this.currentTranslate = -slideWidth * (items.length - this.numClones * 2);
//         this.promotion.style.transform = `translateX(${this.currentTranslate}px)`;
//         setTimeout(() => {
//           this.promotion.style.transition = "transform 0.3s ease-out"; // 애니메이션 복구
//         }, 50);
//       }
//     }

//     addHoverEvents() {
//       this.addEventListener("mouseenter", () => {
//         this.isPausedByUser = true;
//         this.stopAutoSlide();
//       });

//       this.addEventListener("mouseleave", () => {
//         this.isPausedByUser = false;
//         this.startAutoSlide();
//       });
//     }

//     addDragEvents() {
//       const slider = this.promotion;
//       let isDragging = false;
//       let startX = 0;
//       let prevTranslate = 0;
//       let lastMoveTime = 0;
//       let velocity = 0;

//       slider.querySelectorAll("img").forEach((img) => {
//         img.addEventListener("dragstart", (e) => e.preventDefault());
//       });

//       const startDrag = (clientX) => {
//         isDragging = true;
//         startX = clientX;
//         prevTranslate = this.currentTranslate;
//         lastMoveTime = Date.now();
//         this.stopAutoSlide(); 
//         slider.style.transition = "none"; 
//       };

//       const moveDrag = (clientX) => {
//         if (!isDragging) return;
//         const diffX = clientX - startX;
//         const currentTime = Date.now();
//         const timeDiff = currentTime - lastMoveTime;

//         velocity = diffX / (timeDiff || 1);
//         lastMoveTime = currentTime;

//         if (Math.abs(velocity) > 50) {
//           velocity = 50 * Math.sign(velocity);
//         }

//         this.currentTranslate = prevTranslate + diffX;
//         slider.style.transform = `translateX(${this.currentTranslate}px)`;
//       };

//       const endDrag = () => {
//         if (!isDragging) return;
//         isDragging = false;
//         slider.style.transition = "transform 0.3s ease-out"; 

//         const slideWidth = this.querySelector(".promotion__item").offsetWidth;
//         const index = Math.round(this.currentTranslate / -slideWidth);
//         this.currentTranslate = index * -slideWidth;
//         slider.style.transform = `translateX(${this.currentTranslate}px)`;

//         requestAnimationFrame(() => {
//           slider.style.transition = "transform 0.3s ease-out";
//           slider.style.transform = `translateX(${this.currentTranslate}px)`;
//         });

//         this.checkInfiniteLoop();

//         setTimeout(() => {
//           this.startAutoSlide();
//         }, 1000);
//         setTimeout(() => {
//           this.checkInfiniteLoop();
//         }, 300);
//       };

//       slider.addEventListener("mousedown", (e) => {
//         e.preventDefault();
//         startDrag(e.clientX);
//       });

//       slider.addEventListener("mousemove", (e) => {
//         e.preventDefault();
//         moveDrag(e.clientX);
//       });

//       slider.addEventListener("mouseup", endDrag);
//       slider.addEventListener("mouseleave", endDrag);

//       slider.addEventListener("touchstart", (e) => startDrag(e.touches[0].clientX));
//       slider.addEventListener("touchmove", (e) => moveDrag(e.touches[0].clientX));
//       slider.addEventListener("touchend", endDrag);
//     }
//     scrollingPlay() {
//       this.classList.remove('scrolling-promotion--paused');
//     }

//     scrollingPause() {
//       this.classList.add('scrolling-promotion--paused');
//     }
//   }

//   customElements.define('scrolling-promotion', ScrollingPromotion);
// }
